// components/projectPage/ChapterActionsMenu.jsx
import React, { Component } from "react";
import ActionKebabMenu from "../../../components/ActionKebabMenu";

/**
 * Props:
 * - chapter: { id, title, ... }
 * - readOnly?: boolean  (disable destructive actions for archived projects)
 * - onDelete?(chapterId: string)
 * - extraItems?: Array<...>  // optional extra menu items to append
 */
export default class ChapterActionsMenu extends Component {
 
  render() {
    const { chapter, readOnly, items } = this.props;
    if (!chapter) return null;

    return (
      <ActionKebabMenu
        placement="row"
        items={items}
        triggerLabel="Chapter actions"
        triggerClassName="btn subtle menu-btn"
        buttonTitle={
            this.props.readOnly
            ? "Chapter actions (disabled while archived project)"
            : "Chapter actions"
        }
        disabled={!!readOnly}
        />

    );
  }
}
